module.exports = __webpack_public_path__ + "img/logo.670fad50.svg";